import axios, { config } from '..';
import { ADD_ARTIST_SUCCESS, ADD_ARTIST_FAILED } from '../../actionTypes';

export default (body) => async (dispatch) => {
  try {
    const response = await axios.post('/providers/artists/new', body, config);
    const {
      data: { message },
    } = response;

    dispatch({
      type: ADD_ARTIST_SUCCESS,
      message,
    });
  } catch (err) {
    let error = {};
    if (err.response) {
      const {
        data: { status, message },
      } = err.response;
      error = { status, message };
    } else {
      error = {
        status: 500,
        message: err.message,
      };
    }

    dispatch({ type: ADD_ARTIST_FAILED, error });
  }
};
